import Ajax from '../js/common/ajax';

export default {
    // 资产卡片
    assets: {
        list(params = {}) { return Ajax.get('/assets', params); },
        load(id) { return Ajax.get(`/assets/${id}`); },
        delete(id) { return Ajax.delete(`/assets/${id}`); },
        save(params = {}) { return Ajax.post('/assets', params); },
        update(params = {}) { return Ajax.put('/assets', params); },
        /** 下拉选项：类别/科目/部门 */
        options() { return Ajax.get('/assets/options'); },
        /** 计提折旧 */
        generateDepreciation(period) { return Ajax.post(`/assets/generate-depreciation?period=${period}`); },
        /** 折旧明细表 */
        depList(params = {}) { return Ajax.get('/assets/dep-list', params); },
        /** 资产汇总 groupBy=type|dept */
        summary(params = {}) { return Ajax.get('/assets/summary', params); },
        /** 资产对账 */
        check(params = {}) { return Ajax.get('/assets/check', params); },
        /** 处置 */
        dispose(params = {}) { return Ajax.post('/assets/dispose', params); },
        /** 复制 */
        copy(id) { return Ajax.post(`/assets/copy/${id}`); },
        /** 合并（勾选≥2条，数量/原值/折旧求和） */
        merge(params = {}) { return Ajax.post('/assets/merge', params); },
        /** 取消合并（主卡按快照还原，被并入卡片恢复） */
        cancelMerged(id) { return Ajax.delete(`/assets/merge/${id}`); },
        /** 拆分（主卡变拆1，按数量插入拆N子卡） */
        split(id, splitDate, rows) { return Ajax.post(`/assets/split/${id}?splitDate=${splitDate}`, rows); },
        /** 取消拆分（删除拆N子卡，主卡按快照还原） */
        cancelSplit(id) { return Ajax.delete(`/assets/split/${id}`); },
        /** 导入 Excel */
        importData(formData) { return Ajax.post('/assets/import', formData); }
    },
    // 资产类别
    assetsType: {
        list(params = {}) { return Ajax.get('/assets-type', params); },
        load(id) { return Ajax.get(`/assets-type/${id}`); },
        delete(id) { return Ajax.delete(`/assets-type/${id}`); },
        save(params = {}) { return Ajax.post('/assets-type', params); },
        update(params = {}) { return Ajax.put('/assets-type', params); }
    },
    // 折旧明细（基础 CRUD）
    assetsDepreciation: {
        list(params = {}) { return Ajax.get('/assets-depreciation', params); },
        delete(id) { return Ajax.delete(`/assets-depreciation/${id}`); }
    }
};
